<template>
    <div id="app">
        <nav class="navbar navigation-border-bottom" role="navigation" aria-label="dropdown navigation">
            <div class="container">
                <a class="navbar-item logo">
                    <!-- <img :src="require('@/assets/img/logo.svg')" alt="Weap.io logo" width="40px" height="28px">
                    <span>Weap.io</span> -->
                    <img :src="require('@/assets/img/logo-new.svg')" style="height:28px;">
                </a>

                <div class="navbar-menu">
                <div class="navbar-start">
                    <router-link :to="{ name: 'dashboard' }" :class="{ 'navbar-item-custom-active': isActiveRoute(['dashboard']) }" class="navbar-item navbar-item-custom navbar-item-custom-hover-and-active">
                        <span class="menu-item"><font-awesome-icon icon="home"/>&nbsp;&nbsp;Dashboard</span>
                    </router-link>
                    <router-link :to="{ name: 'cloudlets' }" :class="{ 'navbar-item-custom-active': isActiveRoute(['cloudlets', 'showCloudlet']) }" class="navbar-item navbar-item-custom navbar-item-custom-hover-and-active">
                        <span class="menu-item"><font-awesome-icon :icon="['fas', 'cloud']"/>&nbsp;&nbsp;Provider Snapshots</span>
                    </router-link>
                    <!-- <router-link :to="{ name: 'databases' }" :class="{ 'navbar-item-custom-active': isActiveRoute(['databases', 'showDatabase']) }" class="navbar-item navbar-item-custom navbar-item-custom-hover-and-active">
                        <span class="menu-item"><font-awesome-icon :icon="['fas', 'database']"/>&nbsp;&nbsp;Database Backups</span>
                    </router-link> -->
                    <div class="navbar-item navbar-item-custom is-hoverable" :class="{ 'navbar-item-custom-active': isActiveRoute(['mysqlDatabases', 'postgresqlDatabases']) }" style="margin-top: 14px; border-radius: 6px; padding: 21px; cursor: pointer">
                        <a>
                            <span><font-awesome-icon icon="database" class="user-icon"/></span>
                            <span class="user-email">Database Backups</span>
                        </a>
                        <div class="navbar-dropdown" style="border-top: none; border-top-left-radius: 5px; border-top-right-radius: 5px;">
                            <router-link class="navbar-item" :to="{ name: 'mysqlDatabases', }" style="color: #6c757d;">
                                <!-- <span><font-awesome-icon icon="database"/></span> -->
                                <span style="padding-left:10px;">MySQL Backups</span>
                            </router-link>
                            <router-link class="navbar-item" :to="{ name: 'postgresqlDatabases', }" style="color: #6c757d;">
                                <!-- <span><font-awesome-icon icon="database"/></span> -->
                                <span style="padding-left:10px;">PostgreSQL Backups</span>
                            </router-link>
                        </div>
                    </div>
                    <router-link :to="{ name: 'files' }" :class="{ 'navbar-item-custom-active': isActiveRoute(['files', 'showFile']) }" class="navbar-item navbar-item-custom navbar-item-custom-hover-and-active">
                        <span class="menu-item"><font-awesome-icon :icon="['fas', 'folder']"/>&nbsp;&nbsp;File Backups</span>
                    </router-link>
                </div>
                <div class="navbar-end">
                    <div class="headway-changelog navbar-item is-hidden-touch">
                        <transition name="fade">
                            <a v-show="headwayInitialized" style="font-size: 13px; color:#ffffff; font-weight: bold;" href="#" class="changelog-link">Updates</a>
                        </transition>
                    </div>
                    <div class="navbar-item navbar-item-custom-dropdown is-hoverable" style="margin-top: 16px;">
                        <a class="navbar-link">
                            <span><font-awesome-icon icon="user" class="user-icon"/></span>
                            <span class="user-email">{{ email }}</span>
                        </a>
                        <div class="navbar-dropdown" style="border-top: none; border-top-left-radius: 5px; border-top-right-radius: 5px;">
                            <router-link class="navbar-item" :to="{ name: 'detailsSettings', }" style="color: #6c757d;">
                                <span><font-awesome-icon icon="cog"/></span>
                                <span style="padding-left:10px;">Settings</span>
                            </router-link>

                            <router-link class="navbar-item" :to="{ name: 'serversSettings', }" style="color: #6c757d;">
                                <span><font-awesome-icon icon="server"/></span>
                                <span style="padding-left:10px;">Servers</span>
                            </router-link>
                            <router-link class="navbar-item" :to="{ name: 'storagesSettings', }" style="color: #6c757d;">
                                <span><font-awesome-icon icon="hdd"/></span>
                                <span style="padding-left:10px;">Storages</span>
                            </router-link>

                            <hr class="navbar-divider">

                            <router-link class="navbar-item" :to="{ name: 'logout', }" style="color: #6c757d">
                                <span><font-awesome-icon icon="sign-out-alt"/></span>
                                <span style="padding-left:10px;">Logout</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </nav>
        <div class="container">
            <router-view/>
        </div>
    </div>
    <!-- <div id="app">
        <div id="nav">
            <router-link to="/">Home</router-link> |
            <router-link to="/dashboard">Dashboard</router-link>
        </div>
        <router-view/>
    </div> -->
</template>

<script>
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core';

export default {
    created() {
        library.add(faCheckCircle);
    },

    data() {
        return  {
            email: null,
            headwayInitialized: false,
        }
    },

    mounted() {
        this.email = localStorage.getItem('email');
        this.initHeadway();
        this.listenEvents();
    },

    methods: {
        initHeadway() {
            let vm = this;

            function initConfig() {
                if (typeof Headway == 'undefined') {
                    setTimeout(initConfig, 1000);
                } else {
                    var HW_config = {
                        selector: ".headway-changelog",
                        account:  "yoXa3x",
                        trigger: ".headway-changelog",
                    }

                    Headway.init(HW_config);
                    vm.headwayInitialized = true;
                }
            }

            setTimeout(initConfig, 1000);
        },

        isActiveRoute(routes) {
            let currentRouteName = this.currentRouteName;
            
            for (var i = 0; i < routes.length; i++) {
                if (routes[i] == currentRouteName) {
                    return true;
                }
            }

            return false;
        },

        listenEvents() {
            Event.$on('updateEmailInLocalStorage', (email) => {
                localStorage.email = email;
                this.email = localStorage.getItem('email');
            });
        },
    },

    computed: {
        currentRouteName() {
            return this.$route.name;
        },
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 3s
}

.fade-enter, .fade-leave-to {
  opacity: 0
}
</style>
